import { postsPart1 } from "./postsData-part1";
import { postsPart2 } from "./postsData-part2";
import { postsPart3 } from "./postsData-part3";
import { postsPart4 } from "./postsData-part4";
import { postsPart5 } from "./postsData-part5";
import { postsPart6 } from "./postsData-part6";
import { storesPart1 } from "./storesData-part1";
import { storesPart2 } from "./storesData-part2";
import { storesPart3 } from "./storesData-part3";
import { topics } from "./topicsData";
import { locations } from "./locationsData";
import { pages } from "./pagesData";

export const posts = [...postsPart1, ...postsPart2, ...postsPart3, ...postsPart4, ...postsPart5, ...postsPart6];
export const stores = [...storesPart1, ...storesPart2, ...storesPart3];
export { topics, locations, pages };